var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.description !== '')?_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:({content: _vm.description}),expression:"{content: description}",modifiers:{"right":true}}],class:_vm.plotInfoClass,attrs:{"src":"images/info32.png","width":"16","height":"16","alt":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }